window.onWizzyScriptLoaded = function () {
  // for handeling wizzy-results-rendered class
  handleInputEvent("#mob-search");
  handleInputEvent("#mob-search-mob");

  if (typeof wizzyInterval === "undefined") {
    var wizzyInterval = setInterval(function () {
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push(
        "#page-content"
      );

      if (window.wizzyConfig) {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "header input#mob-search",
          type: "search",
        };

        clearInterval(wizzyInterval);
      }
    }, 10);
  }

  function checkForQuery(q) {
    if (q.toLowerCase() === "argan" || q.toLowerCase() === "the argan") {
      return true;
    }
    return false;
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      // Setting Identifier for Autocomplete :-
      payload.common.lazyDOMConfig.searchInputIdentifiers = [];
      payload.common.lazyDOMConfig.searchInputIdentifiers.push({
        dom: "#mob-search",
        type: "text",
      });
      // Setting Identifier for Search :-
      payload.common.lazyDOMConfig.contentDOMIdentifiers = [];
      payload.common.lazyDOMConfig.contentDOMIdentifiers.push("#page-content");
      // Changing wizzy autocomplete div position:-
      // const elementToMove = document.querySelector(".wizzy-body-end-wrapper");
      // const parentElement = elementToMove.parentNode.parentNode;
      // parentElement.parentNode.insertBefore(elementToMove, parentElement);

      // const elementToMove2 = document.querySelector("#search_mini_form");
      // const parentElement2 = elementToMove2.parentNode.parentNode;
      // parentElement2.parentNode.insertBefore(elementToMove2, parentElement2);

      // Search as you type
      payload.search.configs.general.behaviour = "search_as_you_type";
      payload.search.configs.general.minQueryLength = 1;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.swatches = JSON.stringify([
        {
          key: "Title",
        },
      ]);
      if (typeof data.q !== "undefined") {
        if (checkForQuery(data.q)) {
          data.sort.unshift({
            field: "product_WizzyScore_tags:float",
            order: "desc",
          });
        }
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
    function (data) {
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
    function (data) {
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents
      .BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (dataregister) {
      var data = dataregister.suggestions;

      // Function to group items by 'group' property
      function groupItemsByGroup(data) {
        return data.reduce((acc, item) => {
          const group = item.group;
          if (!acc[group]) {
            acc[group] = [];
          }
          acc[group].push(item);
          return acc;
        }, {});
      }

      // Group the items
      const groupedItems = groupItemsByGroup(data);

      // Function to generate HTML for each group, prioritizing "others" group
      function generateHTML(groupedItems) {
        let html = "";

        // Render the "others" group first if it exists
        if (groupedItems["others"]) {
          html += `<div class="others intial-search-display">`;
          html += `<h2>Trending Searches</h2> <div class="search-custom-results-wizzy">`; // Add group title
          groupedItems["others"].forEach((item) => {
            html += `<li class="autocomplete-item">
            <a data-selectable="true" data-searchterm="${item.label}" href="#" class="autocomplete-link" data-index="${item.index}"> 
            <span class="wizzy-autocomplete-label"> ${item.label} </span> 
            <span class="autocomplete-text-wrapper"></span>
            </a> 
            </li>`;
          });
          html += `</div></div>`;
          delete groupedItems["others"]; // Remove it after rendering
        }
        var search_input_val = ($("#mob-search").val() || "").toString();
        var search_input_val_mob = ($("#mob-search-mob").val() || "").toString();

        // Render the rest of the groups

        if (
          !(search_input_val.length >= 2) &&
          !(search_input_val_mob.length >= 2)
        ) {
          for (const group in groupedItems) {
            html += `<div class="${group} intial-search-display">`;
            html += `<h2> Top Categories </h2><div class="search-custom-results-wizzy">`; // Add group title
            groupedItems[group].forEach((item) => {
              html += `<li class="autocomplete-item">
              <a data-selectable="true" data-searchterm="${item.label}" href="#" class="autocomplete-link" data-index="${item.index}">
              <span class="wizzy-autocomplete-label"> ${item.label} </span> 
              <span class="autocomplete-text-wrapper"></span>
              </a> 
              </li>`;
            });
            html += `</div></div>`;
          }
        }

        return html;
      }

      // Generate the HTML
      const html = generateHTML(groupedItems);

      // Update the autocomplete suggestions list with the generated HTML
      // setTimeout(() => {
      //   $('.autocomplete-suggestions-list').empty();
      // $('.autocomplete-suggestions-list').html(html);
      // }, 20);

      // Update dataregister with the generated HTML
      // dataregister.html = html;
      return dataregister;
    }
  );

  // On click mobile search icon:-
  $("body").on("click", ".mobile_search__icon", function () {
    $(".wizzy-search-input").click();
    $(".wizzy-search-input").focus();
  });

  // After wizzy products rendered :-
  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
  //   function (payload) {
  //     if ($("body").hasClass("open__search_top")) {
  //       $(".cross___icon_cstm").click();
  //     }
  //     // $(".wizzy-autocomplete-suggestions").hide();
  //     if (screen.width > 800) {
  //       $(".hidden-desktop").css("display", "none");
  //     }
  //     // Notify block css
  //     var notifyBlock = $(".popup-pincode.notify.align-left")[0];
  //     $(".button.product-atc-btn.cstm-notify").click(function () {
  //       $(notifyBlock).css("display", "block");
  //     });
  //     return payload;
  //   }
  // );

  let cartItems = [];

function getCartItems() {
  return $.getJSON("/cart.js", function (cart) {
    cartItems = cart.items;
  });
}

function updateSearchCartUI() {

  $(".quantity-wrapper").each(function () {

    const qtyWrapper = $(this);

    const variantId = qtyWrapper.attr("data-qty-variant-id");

    const cartItem = cartItems.find(
      (item) => String(item.variant_id) === String(variantId)
    );

    const productCard = qtyWrapper.closest(".wizzy-result-product");

    // Product exists in cart
    if (cartItem) {

      qtyWrapper.find('.quantity').addClass('active');

      qtyWrapper
        .find(".quantity-input")
        .val(cartItem.quantity);

      // productCard
      //   .find(".product-atc-btn")
      //   .hide();

    } else {

      qtyWrapper.find('.quantity').removeClass('active');

      // productCard
      //   .find(".product-atc-btn")
      //   .show();
    }
  });
}

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
  async function (payload) {

    if ($("body").hasClass("open__search_top")) {
      $(".cross___icon_cstm").click();
    }

    if (screen.width > 800) {
      $(".hidden-desktop").css("display", "none");
    }

    var notifyBlock = $(".popup-pincode.notify.align-left")[0];

    $(".button.product-atc-btn.cstm-notify").click(function () {
      $(notifyBlock).css("display", "block");
    });

    // Get latest cart
    await getCartItems();

    // Update qty UI
    updateSearchCartUI();

    return payload;
  }
);


  // Template replace
  $(document).ready(function () {
    replaceTemplate("wizzy-search-results-product");
    // replaceTemplate("wizzy-autocomplete-topproducts");
    // replaceTemplate("wizzy-search-empty-results");
  });
  // No result page's products
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig.search.view.noProductsFoundDOM = ".wizzy-main-content";
      payload.search.configs.noProductsFound = {
        showProducts: true,
        defaultPool: {
          method: "filters",
          expiry: "session",
          data: {
            productsCount: 6,
            categories: ["best-sellers"],
          },
        },
      };
      if (!payload.pageStore.groupedFilteredProducts)
        payload.pageStore.groupedFilteredProducts = {};
      return payload;
    }
  );
  // Adding functionalities for tags etc
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((item) => {
        if (item.swatches.length > 0) {
          if (item.swatches[0].values.length > 0) {
            if (item.swatches[0].values[0].value === "Default Title") {
              item.swatches = null;
            }
          }
        }

        item.product_Size = false;
        item.hoverImage = item.mainImage;
        item.randomNumber = parseInt(Math.random() * 30);
        item.attributes.forEach((attr) => {
          if (attr.id === "product_tags") {
            let tags = attr.values[0].value[0];
            tags = tags.split(",");

            let buy3 = tags.filter((item2) => {
              let current_size = item.sizes[0]?.value;
              let buy_tag = "buy_@_1399";
              // let buy_tag2 = 'buy_@_1799 ' + current_size;
              if (item2.includes(buy_tag)) {
                return true;
              }
              return false;
            });
            if (buy3.length > 0) {
              item.ishavingbuy3tag = true;
            } else {
              item.ishavingbuy3tag = false;
            }
          }
          if (attr.id === "product_demand_custom") {
            item.productType = attr.values[0].value[0];
          }
          if (attr.id === "product_overlay_tags") {
            item.overlayTag = attr.values[0].value[0];
          }
          if (attr.id === "product_vendor") {
            item.vendor = attr.values[0].value[0];
          }
          if (attr.id === "product_value_tags_front_end_tags") {
            item.buyTag = attr.values[0].value[0];
          }
          if (attr.id == "product_reviews_spr") {
            item.reviews = attr.values[0].value[0];
            var reviewsData = item.reviews;
            if ($(reviewsData)?.get(4)?.innerHTML) {
              item.hasReviews = "yes";
              var customData = JSON.parse($(reviewsData)[4].innerHTML);
              var reviewCount = customData["reviewCount"];
              var ratingValue = customData["ratingValue"];
              item.reviewCount = reviewCount;
              item.ratingValue = parseFloat(ratingValue).toFixed(1);
            }
          }
          if (attr.id === "product_product_size_custom") {
            item.product_Size_value = attr.values[0].value[0].toUpperCase();
            item.product_Size = true;
          }
        });
        if (item.price) {
          item.price = parseInt(item.price.replace(/,/g, ""));
        }
        item.sellingPrice = parseInt(item.sellingPrice.replace(/,/g, ""));
      });
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.map((product, index) => {
        let attributes = product.attributes;
        let productctVarient = attributes.filter(
          (v) => v.id === "product_variant_ids"
        );
        if (productctVarient.length) {
          product.varientId = productctVarient[0].values[0].value[0];
        } else {
          product.varientId = product.id;
        }
      });
      return payload;
    }
  );
  $("body").on("click", ".wizzy-view-more", function () {
    $(".wizzy-search-form").submit();
  });
  // setInterval(function () {
  //   if ($(".pretty-select.id-wizzy-sort-select") != null) {
  //     // $("#wizzy-sort-select").moveTo(".wizzy-sort-container");
  //     $(".pretty-select.id-wizzy-sort-select").remove();
  //   }
  // }, 200);
  //typePhrase();

  // $("body").on("click", ".autocomplete-link", (e) => {
  //   let searchedTerm = $(e.target).attr("data-searchterm");
  //   if (searchedTerm == "buy 3 @ ₹1399") {
  //     e.stopImmediatePropagation();
  //     window.location.href = "/collections/buy-3-at-1399";
  //   }
  // });

  $("body").on("click", ".autocomplete-link", (e) => {
    e.stopImmediatePropagation();
    let searchedTerm = $(e.currentTarget)
      .children(".wizzy-autocomplete-label")
      .text()
      .trim();
    switch (searchedTerm) {
      case "Serum":
        window.location.href =
          "https://lovebeautyandplanet.in/collections/bestsellers";
        break;
      case "Hair care":
        window.location.href =
          "https://lovebeautyandplanet.in/collections/hair-care";
        break;
      case "Body Care":
        window.location.href =
          "https://lovebeautyandplanet.in/collections/body-wash-and-body-lotion";
        break;
      case "Buy3 @1399":
        window.location.href =
          "https://lovebeautyandplanet.in/collections/bundle-offers";
        break;
      case "Combos":
        window.location.href =
          "https://lovebeautyandplanet.in/collections/combos";
        break;
      case "New Launches":
        window.location.href =
          "https://lovebeautyandplanet.in/collections/new-launches";
        break;
      case "Argan":
        window.location.href =
          "https://lovebeautyandplanet.in/collections/argan-oil-lavender";
        break;
      case "Onion":
        window.location.href =
          "https://lovebeautyandplanet.in/collections/onion-blackseed-patchouli";
        break;
      default:
        null;
    }
  });

  // Added 'Trending' for default suggestion :-
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_WRAPPER_RENDER,
    function (payload) {
      var response = payload.suggestions;
      const parser = new DOMParser();

      // Convert the HTML string to a jQuery object
      var $html = $(response);

      // Move Trending Searches items to a separate div
      var trendingSearches = $html
        .find('.autocomplete-item-head[data-index="2"]')
        .nextUntil(".autocomplete-item-head");
      var trendingSearchesContainer = $(
        '<div class="others intial-search-display"><h2>Trending Searches</h2><div class="search-custom-results-wizzy"></div></div>'
      );
      trendingSearchesContainer
        .find(".search-custom-results-wizzy")
        .append(trendingSearches);

      // Move Top Categories items to a separate div
      var topCategories = $html
        .find('.autocomplete-item-head[data-index="0"]')
        .nextUntil(".autocomplete-item-head");
      var topCategoriesContainer = $(
        '<div class="categories intial-search-display"><h2>Top Categories</h2><div class="search-custom-results-wizzy"></div></div>'
      );
      topCategoriesContainer
        .find(".search-custom-results-wizzy")
        .append(topCategories);

      // Clear the original content
      $html.find(".autocomplete-suggestions-list").html("");

      // Append both containers to the main list
      $html
        .find(".autocomplete-suggestions-list")
        .append(trendingSearchesContainer);

      var search_input_val = ($("#mob-search").val() || "").toString();
      var search_input_val_mob = ($("#mob-search-mob").val() || "").toString();

      // Render the rest of the groups

      if (
        !(search_input_val.length >= 2) &&
        !(search_input_val_mob.length >= 2)
      ) {
        $html
          .find(".autocomplete-suggestions-list")
          .append(topCategoriesContainer);
        // $html.find('.categories.intial-search-display').empty();
      }

      if (search_input_val.length == 1) {
        $html.find(".others.intial-search-display").empty();
      }
      if (search_input_val_mob.length == 1) {
        $html.find(".others.intial-search-display").empty();
      }

      // Convert the manipulated jQuery object back to HTML string
      var manipulatedHtmlString = $html.prop("outerHTML");

      const doc = parser.parseFromString(manipulatedHtmlString, "text/html");
      // Adding wizzy-default class
      const liElement = doc.getElementsByClassName("autocomplete-item-head")[0];

      payload.suggestions = doc.documentElement.outerHTML;

      // if (inputHasValue() == false) {
      //   payload.suggestions = doc.documentElement.outerHTML;
      // }
      return payload;
    }
  );
};
// ---------------------- Functions Declaration -------------------->

function handleInputEvent(inputId) {
  if ($(inputId).length) {
    $(inputId).on("input", function () {
      if ($(this).val() === "") {
        $("body").removeClass("wizzy-search-results-rendered");
      }
    });
  }
}

const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};
// Wizzy Animated Placeholder function declare:-
// let placeholderText;
// if (screen.width >= 768) {
//   placeholderText = document.getElementById("mob-search");
// }
// if (screen.width <= 768) {
//   placeholderText = document.getElementById("mob-search");
// }
// const phrases = [
//   "Search for Hair Care",
//   "Search for Body Care",
//   "Search for Bestsellers",
// ];
// let index = 0;
// let typingTimer;
// function typePhrase() {
//   const phrase = phrases[index];
//   const len = phrase.length;
//   let i = 0;
//   typingTimer = setInterval(function () {
//     if (i === len) {
//       clearInterval(typingTimer);
//       setTimeout(erasePhrase, 1000); // Wait for 1 second before erasing
//     } else {
//       const currentText = placeholderText.getAttribute("placeholder");
//       placeholderText.setAttribute(
//         "placeholder",
//         currentText + phrase.charAt(i)
//       );
//       i++;
//     }
//   }, 100); // Change the speed of typing by changing this value
// }

// function erasePhrase() {
//   const currentText = placeholderText.getAttribute("placeholder");
//   const len = currentText.length;
//   let i = len - 1;
//   typingTimer = setInterval(function () {
//     if (i === -1) {
//       clearInterval(typingTimer);
//       index++;
//       if (index === phrases.length) {
//         index = 0;
//       }
//       // setTimeout(typePhrase, 1000); // Wait for 1 second before typing the next phrase
//     } else {
//       const newText = currentText.slice(0, i);
//       placeholderText.setAttribute("placeholder", newText);
//       i--;
//     }
//   }, 50); // Change the speed of erasing by changing this value
// }
// On scroll sort div issue
(function ($) {
  $.fn.moveTo = function (selector) {
    return this.each(function () {
      var cl = $(this).clone();
      $(cl).appendTo(selector);
      $(this).remove();
    });
  };
})(jQuery);

$("body").on("click", ".autocomplete-link", (e) => {
  let searchedTerm = $(e.target)
    .closest("[data-searchterm]")
    .attr("data-searchterm");
  if (searchedTerm == "buy 3@1399") {
    e.stopImmediatePropagation();
    window.location.href = "/collections/bundle-offers";
  }
  if (searchedTerm == "hair care") {
    e.stopImmediatePropagation();
    window.location.href = "/collections/hair-care";
  }
  if (searchedTerm == "body care") {
    e.stopImmediatePropagation();
    window.location.href = "/collections/body-wash-and-body-lotion";
  }
  if (searchedTerm == "hair fall") {
    e.stopImmediatePropagation();
    window.location.href = "/collections/onion-blackseed-patchouli";
  }
  if (searchedTerm == "bestsellers") {
    e.stopImmediatePropagation();
    window.location.href = "/collections/best-sellers";
  }
  if (searchedTerm == "Argan") {
    e.stopImmediatePropagation();
    window.location.href = "/collections/argan-oil-lavender";
  }
  if (searchedTerm == "Onion") {
    e.stopImmediatePropagation();
    window.location.href = "/collections/onion-blackseed-patchouli";
  }
});

function inputHasValue() {
  if (screen.width >= 800) {
    var inputValue = $($(".wizzy-search-input")[1]).val();
  } else {
    var inputValue = $("#st-search-input-mobile").val();
  }
  if (inputValue.length >= 1) {
    return true;
  }
  return false;
}

// Wizzy Lazy Init
// const wizzyLazyAssetUtils = {
//   isWizzyLazyLoaded: false,
//   isCollectionEnabled: false,
//   wizzyStore: JSON.parse(window.localStorage.getItem("wizzy_store")) ?? false,
//   collectionId:
//     document
//       .querySelector("[data-collection-id]")
//       ?.getAttribute("data-collection-id") ?? false,
//   productId:
//     document
//       .querySelector("[data-product-id]")
//       ?.getAttribute("data-product-id") ?? false,
//   pageHandle:
//     document
//       .querySelector("[data-page-handle]")
//       ?.getAttribute("data-page-handle") ?? false,
//   currentEle: null,
//   enableWizzyAssets(targetEle = null) {
//     if (!this.isWizzyLazyLoaded) {
//       this.isWizzyLazyLoaded = true;
//       window.wizzyLazyAssets.load();
//     }
//   },
//   isValidTargetEleToEnable(targetEle) {
//     return (
//       targetEle.getAttribute("name") == "q" &&
//       targetEle.getAttribute("type") == "text"
//     );
//   },
//   clickCondition(targetEle) {
//     var self = wizzyLazyAssetUtils;
//     return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
//   },
//   keyDownCondition(targetEle) {
//     var self = wizzyLazyAssetUtils;
//     return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
//   },
//   handleInitClick(e) {
//     var self = wizzyLazyAssetUtils;
//     let targetEle = e.target;
//     if (self.clickCondition(targetEle) && !this.isWizzyLazyLoaded) {
//       self.currentEle = targetEle;
//       self.enableWizzyAssets(targetEle);

//       document.removeEventListener("click", self.handleInitClick);
//     }
//   },
//   handleInitKeyDown(e) {
//     var self = wizzyLazyAssetUtils;
//     let targetEle = e.target;
//     if (self.keyDownCondition(targetEle) && !this.isWizzyLazyLoaded) {
//       self.currentEle = targetEle;
//       self.enableWizzyAssets(targetEle);
//       document.removeEventListener("keydown", self.handleInitKeyDown);
//     }
//   },
//   attachEvents() {
//     var self = wizzyLazyAssetUtils;
//     document.addEventListener("click", self.handleInitClick);
//     document.addEventListener("keydown", self.handleInitKeyDown);

//     window.addEventListener("onWizzyScriptLoaded", () => {
//       window.wizzySearchInit();
//     });

//     window.addEventListener("onWizzyInit", () => {
//       if (
//         !document.querySelector("main").classList.contains("wizzy-main-content")
//       ) {
//         document.querySelector("main").classList.add("wizzy-main-content");
//       }

//       if (self.currentEle) {
//         setTimeout(() => {
//           self.currentEle.click();
//         }, 10);
//       }

//       document.removeEventListener("click", self.handleInitClick);
//     });
//   },
//   isOnValidaProductPage() {
//     let self = wizzyLazyAssetUtils;
//     return (
//       self.wizzyStore &&
//       typeof self.wizzyStore == "object" &&
//       self.wizzyStore.hasOwnProperty("CLICKED_PRODUCTS") &&
//       typeof self.wizzyStore["CLICKED_PRODUCTS"] == "object" &&
//       self.wizzyStore["CLICKED_PRODUCTS"].hasOwnProperty(self.productId)
//     );
//   },
//   isOnCollectionPage() {
//     let self = wizzyLazyAssetUtils;
//     return (
//       self.isCollectionEnabled &&
//       self.collectionId != undefined &&
//       self.collectionId != "" &&
//       self.collectionId != null
//     );
//   },
//   isNeedToAutoInitWizzy() {
//     var self = wizzyLazyAssetUtils;
//     return (
//       self.pageHandle == "/pages/search" ||
//       self.isOnValidaProductPage() ||
//       self.isOnCollectionPage()
//     );
//   },
//   init() {
//     // typePhrase();

//     var self = wizzyLazyAssetUtils;
//     this.attachEvents();
//     if (!window.wizzyConfigUpdated) {
//       let wizzyCategoryPageInterval = setInterval(() => {
//         if (window.wizzyConfigUpdated) {
//           clearInterval(wizzyCategoryPageInterval);
//           if (self.isNeedToAutoInitWizzy()) self.enableWizzyAssets();
//         }
//       }, 10);
//     } else {
//       if (self.isNeedToAutoInitWizzy()) self.enableWizzyAssets();
//     }
//   },
// };

// window.onload = (e) => wizzyLazyAssetUtils.init();
